import { useEffect, useMemo } from "react";
import TableWidget from "../../../components/tables/TableWidget";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import {
  getAllCutiiPicking,
  getPickingBoxTypes,
  getPickingBoxTmsServices,
} from "../../../redux/api/inventory.api";
import { clearPickingBoxes } from "../../../redux/reducer/inventory.reducer";
import {
  getPickingBoxesTableData,
  pickingBoxesTableHeader,
  getPickingBoxTypeOptions,
  getPickingBoxTmsOptions,
} from "./tableConfigs/pickingBoxesTableConfig";
import PickingBoxesActionButtons from "./components/PickingBoxesActionButtons";
import PickingBoxesHeader from "./components/PickingBoxesHeader";
import { PickingBoxesResponseInterface } from "../../../redux/interfaces/inventory.interface";

export default function PickingBoxStocks() {
  const dispatch = useAppDispatch();
  const list = useAppSelector((state) => state.inventory.pickingBoxes.list);
  const types = useAppSelector((state) => state.inventory.pickingBoxes.types);
  const tmsServices = useAppSelector(
    (state) => state.inventory.pickingBoxes.tmsServices,
  );

  const table = useMemo(
    () =>
      getPickingBoxesTableData(
        (list.data as PickingBoxesResponseInterface | null)?.data ?? [],
        getPickingBoxTypeOptions(types.data),
        getPickingBoxTmsOptions(tmsServices.data),
      ),
    [list.data, types.data, tmsServices.data],
  );
  useEffect(() => {
    dispatch(getAllCutiiPicking());
    dispatch(getPickingBoxTypes());
    dispatch(getPickingBoxTmsServices());
    return () => {
      dispatch(clearPickingBoxes());
    };
  }, [dispatch]);
  return (
    <TableWidget
      tableHeaderData={pickingBoxesTableHeader}
      tableItemsData={table}
      CustomHeaderComponent={PickingBoxesHeader}
      ActionButtonsComponent={PickingBoxesActionButtons}
      tableLoading={
        list.status === "loading" ||
        types.status === "loading" ||
        tmsServices.status === "loading"
      }
      withGlobalSearch={false}
      withGlobalFilter={false}
      withTablePagination={false}
      showSearchForCategories={false}
      emptyTableLabel={
        list.status === "error"
          ? "Lista nu a putut fi incarcata"
          : "Nu exista cutii picking"
      }
    />
  );
}
